import { createFeatureSelector } from '@ngrx/store';
import { State, configFeatureKey } from '../reducers/animation.reducer';

export const selectSidebar = createFeatureSelector<State>(configFeatureKey);
